<template>
  <main class="tsj-home">
    
    <section 
      class="tsj-hero"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <div class="tsj-slider-container">
        <div 
          v-for="(slide, index) in slides" 
          :key="index" 
          class="tsj-slide"
          :class="{ active: currentSlide === index }"
        >
          <div 
            class="tsj-slide-bg" 
            :style="{ 
              backgroundImage: `url(${isDesktop ? slide.imageDesktop : slide.imageMobile})` 
            }"
          ></div>
          <div class="tsj-overlay"></div>

          <div class="tsj-slide-content">
            <span class="tsj-badge animate-gsap">{{ slide.subtitle }}</span>
            <h1 class="tsj-title animate-gsap">{{ slide.title }}</h1>
            <p class="tsj-description animate-gsap">{{ slide.description }}</p>
            
            <div class="animate-gsap">
              <button class="tsj-btn-modern" @click="scrollToCatalog">
                Ver Colección
              </button>
            </div>
          </div>
        </div>

        <div class="tsj-controls">
          <div class="tsj-arrows">
            <button @click="prevSlide" class="arrow-btn">←</button>
            <button @click="nextSlide" class="arrow-btn">→</button>
          </div>
          <div class="tsj-dots">
            <span 
              v-for="(_, i) in slides" 
              :key="i" 
              :class="{ active: currentSlide === i }"
              @click="currentSlide = i"
            ></span>
          </div>
        </div>
      </div>
    </section>

    <div id="catalogo">
      <section v-if="seccionCaballeros" class="tsj-products-section">
        <div class="tsj-container">
          <div class="tsj-section-header-prod">
            <div>
              <h2 class="tsj-title-prod">{{ seccionCaballeros.title }}</h2>
              <p class="tsj-subtitle-prod">Lo más selecto para el hombre de hoy</p>
            </div>
            <button class="tsj-link-btn" @click="goCategory(seccionCaballeros.handle)">Ver todo →</button>
          </div>

          <div class="tsj-products-slider-mobile">
            <div class="tsj-products-grid">
              <ProductCardSuper
                v-for="prod in seccionCaballeros.products"
                :key="prod.id"
                :product="prod"
              />
            </div>
            <div class="btn-center">
              <button class="tsj-link-btn1" @click="goCategory(seccionCaballeros.handle)">
                Ver más →
              </button>
            </div>
          </div>
        </div>
      </section>

      <VideoSocialFeed />

      <section class="tsj-categories-intercalated" v-if="categoriasLimitadas.length">
        <div class="tsj-container">
          <div class="tsj-section-header-boutique">
            <div>
              <span class="tsj-pre-title">Explora</span>
              <h2 class="tsj-section-title">Nuestras Colecciones</h2>
            </div>
            <span class="swipe-hint">Desliza para ver más →</span>
          </div>

          <div class="tsj-categories-slider">
            <div class="tsj-categories-track">
              <button
                v-for="cat in categoriasLimitadas"
                :key="cat.id"
                class="tsj-cat-boutique-card"
                @click="goCategory(cat.handle)"
              >
                <div class="tsj-cat-img-box">
                  <img v-if="cat.image" :src="cat.image" :alt="cat.title" />
                  <div v-else class="tsj-cat-placeholder">🎩</div>
                  <div class="tsj-cat-info-overlay">
                    <span class="tsj-cat-name-modern">{{ cat.title }}</span>
                    <div class="tsj-cat-line"></div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </section>

      <div v-for="sec in restoDeSecciones" :key="sec.id">
        <section class="tsj-products-section">
          <div class="tsj-container">
            <div class="tsj-section-header-prod">
              <div>
                <h2 class="tsj-title-prod">{{ sec.title }}</h2>
                <p class="tsj-subtitle-prod">{{ sec.subtitle }}</p>
              </div>
              <button class="tsj-link-btn" @click="goCategory(sec.handle)">Ver todo →</button>
            </div>

            <div class="tsj-products-slider-mobile">
              <div class="tsj-products-grid">
                <ProductCardSuper
                  v-for="prod in sec.products"
                  :key="prod.id"
                  :product="prod"
                />
              </div>
              <!-- 🔥 Agregado Ver más idéntico al de Caballero al fondo de cada sección -->
              <div class="btn-center">
                <button class="tsj-link-btn1" @click="goCategory(sec.handle)">
                  Ver más →
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer class="tsj-footer">
    </footer>

  </main>
</template>

<script>
import axiosClient from "@/api/axiosClient";
import { useLocationStore } from "@/stores/location";
import ProductCardSuper from "@/views/ProductCardSuper.vue";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import VideoSocialFeed from "@/views/VideoSocialFeed.vue";
gsap.registerPlugin(ScrollTrigger);

import img1 from '@/assets/im.png';
import img2 from '@/assets/imagen22.png';
import img11 from '@/assets/im1.png';
import img22 from '@/assets/im2.png';

export default {
  name: "HomeTiendaSanJudas",
  components: { ProductCardSuper, VideoSocialFeed },

  data() {
    return {
      categoriasRapidas: [],
      secciones: [],
      currentSlide: 0,
      isDesktop: window.innerWidth >= 768,
      touchStartX: 0,
      touchEndX: 0,
      sliderInterval: null,
      slides: [
        {
          title: "ESTILO CON CARÁCTER",
          subtitle: "COLECCIÓN TIENDA SAN JUDAS",
          description: "Gorras y sombreros diseñados para el hombre que sabe lo que quiere.",
          imageDesktop: img11,
          imageMobile: img1
        },
        {
          title: "CALIDAD DE AUTOR",
          subtitle: "BY JESÚS CAVAZOS",
          description: "Lleva la esencia de la música y la tradición en cada detalle.",
          imageDesktop: img22,
          imageMobile: img2
        }
      ]
    };
  },

  computed: {
    locationStore: () => useLocationStore(),
    
    // Filtrar secciones con productos y quitar ofertas
    seccionesValidas() {
      return this.secciones.filter(s => 
        Array.isArray(s.products) && 
        s.products.length > 0 && 
        s.handle !== "ofertas"
      );
    },

    // Buscamos específicamente la sección de caballeros (por título o handle)
    seccionCaballeros() {
      return this.seccionesValidas.find(s => 
        s.handle.toLowerCase().includes('caballero') || 
        s.title.toLowerCase().includes('caballero')
      );
    },

    // Todas las secciones que no son la de Caballeros
    restoDeSecciones() {
      return this.seccionesValidas.filter(s => s.id !== this.seccionCaballeros?.id);
    },

    categoriasLimitadas() {
      return this.categoriasRapidas.slice(0, 8);
    }
  },

  async mounted() {
    await this.cargarHome();
    this.startSlider();
    this.animateSlide();
    window.addEventListener('resize', this.checkScreen);
  },

  watch: {
    "locationStore.selectedStore.id"() { 
      this.cargarHome(); 
    },
    currentSlide() { 
      this.animateSlide(); 
    }
  },

  methods: {
    
    checkScreen() {
      this.isDesktop = window.innerWidth >= 768;
    },
    async cargarHome() {
      try {
        // 1. Verificación de seguridad
        if (!this.locationStore.selectedStore?.id) return;

        // 2. Limpieza previa para forzar el refresco de componentes
        this.secciones = []; 

        // 3. Petición al endpoint
        const { data } = await axiosClient.get("/shopify/home", {
          params: { location_id: this.locationStore.selectedStore.id }
        });

        // 4. Procesar Categorías Rápidas
        this.categoriasRapidas = (data.categoriasRapidas || []).filter(
          c => c.handle !== "home-page" && c.title?.toLowerCase() !== "home page"
        );

        // 5. Procesar Secciones y Productos (PASANDO DATOS PUROS LIMITADOS A 8)
        this.secciones = (data.secciones || []).map(sec => ({
          ...sec,
          products: (sec.products || []).map(prod => {
            return {
              ...prod,
              availableQty: prod.availableQty !== undefined ? prod.availableQty : 1,
              allowBackorder: prod.allowBackorder !== undefined ? prod.allowBackorder : false
            };
          }).slice(0, 8) 
        }));

        // 6. Reiniciar animaciones de GSAP
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.initScrollAnimations) this.initScrollAnimations();
            if (typeof ScrollTrigger !== 'undefined') {
              ScrollTrigger.refresh();
            }
          }, 400);
        });

      } catch (error) { 
        console.error("❌ Error al cargar home:", error); 
      }
    },

    initScrollAnimations() {
      ScrollTrigger.getAll().forEach(t => t.kill());

      // Animación de entrada para las tarjetas de categorías
      gsap.from(".tsj-cat-boutique-card", {
        scrollTrigger: {
          trigger: ".tsj-categories-intercalated",
          start: "top 85%",
        },
        x: 50,
        opacity: 0,
        stagger: 0.1,
        duration: 0.8,
        ease: "back.out(1.7)"
      });

      // Animación para cada sección de productos
      const sections = document.querySelectorAll('.tsj-products-section');
      sections.forEach((section) => {
        const cards = section.querySelectorAll('.tsj-products-grid > *');
        gsap.from(cards, {
          scrollTrigger: { trigger: section, start: "top 85%" },
          y: 30,
          opacity: 0,
          stagger: 0.08,
          duration: 0.7,
          clearProps: "all"
        });
      });
    },

    animateSlide() {
      gsap.fromTo(".tsj-slide.active .animate-gsap", 
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, stagger: 0.15, duration: 0.9, ease: "power3.out" }
      );
    },

    startSlider() { 
      if (this.sliderInterval) clearInterval(this.sliderInterval);
      this.sliderInterval = setInterval(this.nextSlide, 6000); 
    },

    nextSlide() { this.currentSlide = (this.currentSlide + 1) % this.slides.length; },
    prevSlide() { this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length; },

    handleTouchStart(e) { this.touchStartX = e.changedTouches[0].screenX; },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) { diff > 0 ? this.nextSlide() : this.prevSlide(); }
    },

    goCategory(handle) { this.$router.push({ name: "categoria-vista", params: { handle } }); },
    scrollToCatalog() { 
      const el = document.getElementById('catalogo');
      if (el) el.scrollIntoView({ behavior: 'smooth' }); 
    }
  },

  beforeUnmount() {
    if (this.sliderInterval) clearInterval(this.sliderInterval);
    ScrollTrigger.getAll().forEach(t => t.kill());
    window.removeEventListener('resize', this.checkScreen);
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap');

.tsj-home {
  background: #ffffff;
  color: #1a1a1a;
  font-family: 'Montserrat', sans-serif;
  overflow-x: hidden;
  margin-top:120px;
}

.tsj-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* HERO SLIDER */
.tsj-hero {
  position: relative;
  height: 80vh;
  background: #000;
  overflow: hidden;
}
.tsj-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tsj-slide.active { opacity: 1; z-index: 5; }
.tsj-slide-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: top center;
  transform: scale(1.1);
  transition: transform 6s linear;
}
.tsj-slide.active .tsj-slide-bg { transform: scale(1); }
.tsj-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.7));
}
.tsj-slide-content { position: relative; z-index: 10; text-align: center; color: #fff; padding: 0 25px; }
.tsj-badge { display: inline-block;  color: #ffffff; padding: 5px 15px; font-weight: 900; font-size: 0.7rem; letter-spacing: 2px; margin-bottom: 15px; border-radius: 2px; }
.tsj-title { font-size: clamp(2.2rem, 8vw, 5rem); font-weight: 900; text-transform: uppercase; line-height: 0.9; margin-bottom: 15px; text-shadow: 0 10px 30px rgba(0,0,0,0.5); }
.tsj-description { font-size: 1.1rem; max-width: 600px; margin: 0 auto 25px; opacity: 0.9; }
.tsj-btn-modern { padding: 18px 45px; background: #fff; border: none; font-weight: 900; cursor: pointer; text-transform: uppercase; letter-spacing: 1px; transition: 0.3s; box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
.tsj-btn-modern:hover { background: #d9c5b2; color: #fff; transform: translateY(-3px); }

/* PRODUCTOS & SWIPE MOBILE */
.tsj-products-section { padding: 60px 0; }
.tsj-section-header-prod {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 30px;
  border-bottom: 2px solid #f4f4f4;
  padding-bottom: 20px;
}
.tsj-title-prod { font-size: 1.8rem; font-weight: 900; text-transform: uppercase; line-height: 1; }
.tsj-subtitle-prod { font-size: 0.9rem; color: #666; margin-top: 5px; }

/* Contenedor que permite swipe en móvil para productos */
.tsj-products-slider-mobile {
  margin: 0 -20px;
  padding: 0 20px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
.tsj-products-slider-mobile::-webkit-scrollbar { display: none; }

.tsj-products-grid {
  display: flex;
  gap: 15px;
}


/* CATEGORÍAS (SWIPE) */
.tsj-categories-intercalated {
  padding: 80px 0;
  background: #111;
  color: #fff;
}
.tsj-section-header-boutique {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 35px;
}
.tsj-pre-title { color: #d9c5b2; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; letter-spacing: 3px; }
.tsj-section-title { font-size: 2.2rem; font-weight: 900; text-transform: uppercase; }

.tsj-categories-slider {
  margin: 0 -20px;
  padding: 0 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.tsj-categories-slider::-webkit-scrollbar { display: none; }

.tsj-categories-track {
  display: flex;
  gap: 20px;
}
.tsj-cat-boutique-card {
  flex: 0 0 260px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
.tsj-cat-img-box {
  position: relative;
  aspect-ratio: 3 / 4;
  border-radius: 12px;
  overflow: hidden;
  background: #222;
}
.tsj-cat-img-box img { width: 100%; height: 100%; object-fit: cover; transition: 0.8s cubic-bezier(0.4, 0, 0.2, 1); }
.tsj-cat-boutique-card:hover img { transform: scale(1.1); }
.tsj-cat-info-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(transparent 50%, rgba(0,0,0,0.9));
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 25px;
}
.tsj-cat-name-modern { color: #fff; font-weight: 700; text-transform: uppercase; font-size: 1rem; letter-spacing: 1px; }
.tsj-cat-line { width: 40px; height: 3px; background: #d9c5b2; margin-top: 8px; transition: 0.4s; }
.tsj-cat-boutique-card:hover .tsj-cat-line { width: 80px; }

/* DESKTOP ADJUSTMENTS */
@media (min-width: 900px) {
  .tsj-products-slider-mobile {
    margin: 0;
    padding: 0;
    overflow: visible;
  }
  .tsj-products-grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important; 
    gap: 12px;
    padding: 10px 5px;
    width: 100%;
    box-sizing: border-box;
    overflow: visible !important;
  }
  .tsj-products-grid > * {
    flex: none;
  }
  .tsj-cat-boutique-card { flex: 0 0 320px; }
  .tsj-hero { height: 85vh; }
}

/* CONTROLES SLIDER */
.tsj-controls { position: absolute; bottom: 40px; width: 100%; display: flex; flex-direction: column; align-items: center; z-index: 20; }
.tsj-arrows { display: flex; gap: 15px; margin-bottom: 15px; }
.arrow-btn { background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.5); color: #fff; width: 50px; height: 50px; border-radius: 50%; cursor: pointer; backdrop-filter: blur(5px); transition: 0.3s; }
.arrow-btn:hover { background: #fff; color: #000; }
.tsj-dots span { width: 30px; height: 3px; background: rgba(255,255,255,0.3); margin: 0 5px; display: inline-block; cursor: pointer; transition: 0.3s; }
.tsj-dots span.active { background: #d9c5b2; width: 60px; }

.tsj-footer { padding: 60px 20px; text-align: center; background: #fafafa; border-top: 1px solid #eee; }
.tsj-signature { font-weight: 900; text-transform: uppercase; font-size: 1rem; letter-spacing: 2px; color: #000; margin-bottom: 10px; }
.tsj-note { font-size: 0.75rem; color: #999; }

.btn-center {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.tsj-link-btn1 {
  background: none;
  border: none;
  padding: 10px 0;
  cursor: pointer;
  display: flex;

  /* Tipografía */
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #1a1a1a;
  
  /* Layout */
  display: inline-flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: all 0.3s ease;
}


/* BOTÓN "VER TODO" ESTILO BOUTIQUE PREMIUM */
.tsj-link-btn {
  background: none;
  border: none;
  padding: 10px 0;
  cursor: pointer;
  
  /* Tipografía */
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #1a1a1a;
  
  /* Layout */
  display: inline-flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: all 0.3s ease;
}

@media (min-width: 1024px){

  /* HERO más equilibrado */
  .tsj-hero {
    height: 75vh;
  }

  .tsj-title {
    font-size: 3.2rem;
  }

  .tsj-description {
    font-size: 1rem;
    max-width: 500px;
  }

  .tsj-btn-modern {
    padding: 14px 30px;
    font-size: 13px;
  }

  /* SECCIONES */
  .tsj-products-section {
    padding: 50px 0;
  }

  .tsj-title-prod {
    font-size: 1.5rem;
  }

  .tsj-subtitle-prod {
    font-size: 0.85rem;
  }

  /* GRID más fino */
  .tsj-products-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  /* CATEGORÍAS */
  .tsj-section-title {
    font-size: 1.8rem;
  }

  .tsj-cat-boutique-card {
    flex: 0 0 260px;
  }

}
/* Asegura que el badge del card no sea recortado por el slider del home */
.tsj-products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px 5px;
  width: 100%;
  box-sizing: border-box;
}

/* --- FIX DEFINITIVO PARA EL ANCHO EN MÓVIL --- */
@media (max-width: 768px) {
  /* 1. Forzamos que nada se salga de la pantalla */
  html, body {
    overflow-x: hidden;
    width: 100%;
    position: relative;
  }

  /* 2. El contenedor principal debe ser flexible */
  .tsj-home, .cat-page, .layout, .tsj-container {
    width: 100% !important;
    max-width: 100vw !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }

  /* 3. Ajuste al grid de productos */
  .tsj-products-grid, .products-grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    width: 100% !important;
    margin: 0 auto !important;
    box-sizing: border-box !important;
  }

  /* 4. Evitamos que las imágenes o tarjetas empujen el borde */
  .tsj-products-grid > *, .products-grid > * {
    max-width: 100% !important;
    min-width: 0 !important;
    overflow: hidden;
  }
}

.tsj-products-slider-mobile {
  overflow-x: auto;
  overflow-y: visible !important;
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 1200px) {
  .tsj-hero {
    max-width: 1400px;
    margin: 0 auto;
    border-radius: 12px;
    overflow: hidden;
  }
}
.tsj-hero {
  margin-top: 40px;
}
</style>